import * as React from 'react';
import styled from 'styled-components';
import { COLORS, ComponentTextStyle, ComponentXSStyling } from '..';

const Container = styled.div<{variant: TagVariants, isLabelPresent: boolean}>`
  display: flex;
  padding: 4px;
  height: 24px;
  width: calc(100%);
  max-width: fit-content;
  align-items: center;
  justify-content: center;
  min-width: ${props=>props.isLabelPresent ? '64px' : ''};
  border-radius: 2px;
  box-sizing: border-box;

  &.neutral {
    background-color: ${COLORS.neutral_100};
    color: ${COLORS.neutral_600};
  }
  &.positive {
    background-color: ${COLORS.correct_100};
    color: ${COLORS.correct_600};
  }
  &.warning {
    background-color: ${COLORS.warning_100};
    color: ${COLORS.warning_600};
  }
  &.critical {
    background-color: ${COLORS.critical_100};
    color: ${COLORS.critical_600};
  }
  &.accent1 {
    background-color: ${COLORS.accent1_100};
    color: ${COLORS.accent1_600};
  }
  &.accent2 {
    background-color: ${COLORS.accent2_100};
    color: ${COLORS.accent2_600};
  }

`;

const IconContainer = styled.div<{variant: TagVariants}>`
  display: flex;
  width: 16px;
  height: 16px;
  svg {
    width: 16px;
    height: 16px;
  }
`;

const TextContainer = styled.div<{variant: TagVariants, icon: React.ReactNode}>`
  height: 16px;
  padding: 0 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;  
  ${ComponentXSStyling(ComponentTextStyle.Bold, null)}
`;


export type TagVariants = 'neutral' | 'positive' | 'warning' | 'critical' | 'accent1' | 'accent2';

export type TagProps = React.HTMLAttributes<HTMLDivElement> & {
  label?: string;
  icon?: React.ReactNode;
  variant?: TagVariants;
}

const Tag: React.FunctionComponent<TagProps> = ({label, icon, variant='neutral', className, ...rest}) => {
  const cls = `${className ?? ''} ${variant}`;
  return (   
    <Container variant={variant} isLabelPresent={!!label} className={cls} {...rest}>
      {icon && <IconContainer variant={variant} data-testid={'iconContainer'}>
          {icon}
        </IconContainer>
      }
      {label && <TextContainer variant={variant} icon={icon}>
          {label}
        </TextContainer>
      }
    </Container>
  );
};

export default Tag;
